import { MockFactory } from '@tino-frontend/mocks'
import { PaymentLinkDetail, PaymentLinkStatus } from '@types'
import { paymentLinkDetailBaseMock } from './payment-link-detail-base'

export const paymentLinkDetailBilledMock = new MockFactory<PaymentLinkDetail>({
  ...paymentLinkDetailBaseMock.build(),
  status: PaymentLinkStatus.Billed,
  limit_reservation_id: 'limit_reservation_id',
  cashouts: [
    {
      installment_id: 'a1b2c3d4-e5f6-7g8h-9i0j-k1l2m3n4o5p6',
      invoice_id: 'a1b2c3d4-e5f6-7g8h-9i0j-k1l2m3n4o5p6',
      amount_cents: 50000,
      status: 'settled',
      expected_transfer_date: '2025-05-02T00:00:00Z',
    },
    {
      installment_id: 'a1b2c3d4-e5f6-7g8h-9i0j-k1l2m3n4o5p6',
      invoice_id: 'a1b2c3d4-e5f6-7g8h-9i0j-k1l2m3n4o5p6',
      amount_cents: 50000,
      status: 'pending',
      expected_transfer_date: '2025-05-04T00:00:00Z',
    },
    {
      installment_id: 'a1b2c3d4-e5f6-7g8h-9i0j-k1l2m3n4o5p6',
      invoice_id: 'a1b2c3d4-e5f6-7g8h-9i0j-k1l2m3n4o5p6',
      amount_cents: 50000,
      status: 'settled',
      expected_transfer_date: '2025-05-06T00:00:00Z',
    },
  ],
})
